module.exports = __webpack_public_path__ + "static/media/did-you-know-breakin.52339fd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/did-you-know-breakin.png
// module id = 1150
// module chunks = 0